var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { Transition } from 'react-transition-group';
import classNames from 'classnames';
function Child(_a, ref) {
  var _b;
  var cls = _a.prefixCls,
    visible = _a.visible,
    children = _a.children,
    width = _a.width,
    height = _a.height,
    className = _a.className,
    placement = _a.placement,
    closable = _a.closable,
    closeIcon = _a.closeIcon,
    onEnter = _a.onEnter,
    onExited = _a.onExited,
    onCancel = _a.onCancel;
  var enterStyle = {
    transform: 'translate(0, 0)'
  };
  var contentStyle = (_b = {}, _b[placement] = '0px', _b);
  if (placement === 'left' || placement === 'right') {
    contentStyle.width = width;
    contentStyle.height = '100%';
    contentStyle.top = '0px';
  } else if (placement === 'top' || placement === 'bottom') {
    contentStyle.width = '100%';
    contentStyle.height = height;
    contentStyle.left = '0px';
  }
  var transitionStyles = {
    entering: enterStyle,
    entered: enterStyle,
    exiting: {},
    exited: {}
  };
  function renderClose() {
    if (!closable) {
      return null;
    }
    if (closeIcon) {
      return /*#__PURE__*/React.cloneElement(closeIcon, {
        onClick: onCancel
      });
    }
    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(cls, "-times"),
      onClick: onCancel
    }, "\xD7");
  }
  return /*#__PURE__*/React.createElement(Transition, {
    "in": visible,
    timeout: 200,
    appear: true,
    onEnter: onEnter,
    onExited: onExited
  }, function (state) {
    var _a;
    var nextStyles = state !== 'exited' ? contentStyle : {};
    return /*#__PURE__*/React.createElement("div", {
      style: __assign(__assign({}, nextStyles), transitionStyles[state]),
      ref: ref,
      className: classNames(cls, className, (_a = {}, _a["".concat(cls, "-tf-").concat(placement)] = state === 'exited' || state === 'exiting', _a))
    }, renderClose(), children);
  });
}
export default /*#__PURE__*/React.forwardRef(Child);